import React, { useContext, useState, useEffect, createContext } from "react";

const WalletContext = createContext({});
export const WalletProvider = ({ children }) => {
  const [currentWallet, setCurrentWallet] = useState(null);
  const connectMetaMask = async () => {
    // setIsOpenModal(true)
    console.log("Resquesting account...");

    if (window.ethereum) {
      console.log("Meta Mask detected");
      try {
        const accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
        });
        setCurrentWallet(accounts[0]);
      } catch (error) {
        console.log(error);
      }
    } else {
      console.log("Meta Mask not detected");
    }
  };
  return (
    <WalletContext.Provider
      value={{ currentWallet, setCurrentWallet, connectMetaMask }}
    >
      {children}
    </WalletContext.Provider>
  );
};

export function useWallet() {
  const context = useContext(WalletContext);
  return context;
}
